import { render } from "./BoardPopup.vue?vue&type=template&id=d6f1b0ec"
import script from "./BoardPopup.vue?vue&type=script&lang=js"
export * from "./BoardPopup.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/craft-fos-scoutsmap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__